import H from 'constants/httpMethod.const';
import { fromTaxToDto } from 'dto/taxes/fromTaxToDto.dto';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const beCreateTax = actionEndpointBe('beCreateTax', H.post, 'sales/salon/:salonId/taxes/', (options, extra) => ({
  ...options,
  inert: true,
  data: extra?.data,
  toDto: fromTaxToDto,
}));
